export var getMDYFormattedDate = function (date) {
    if (!date) {
        return "";
    }
    var splitDate = date.split("T")[0];
    var _a = splitDate.split("-"), y = _a[0], m = _a[1], d = _a[2];
    return m + "/" + d + "/" + y;
};
export var getTextFormattedDate = function (date) {
    if (!date) {
        return "";
    }
    var splitDate = date.split("T")[0];
    var _a = splitDate.split("-"), y = _a[0], m = _a[1], d = _a[2];
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    var monthIndex = parseInt(m) - 1;
    return months[monthIndex] + " " + d + ", " + y;
};
export var getIsLineClamped = function (element) {
    var _a;
    return element &&
        element.scrollHeight - element.clientHeight >=
            parseInt((_a = element.style) === null || _a === void 0 ? void 0 : _a.fontSize);
};
var URL_DOMAIN_REGEX = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)(\/)?/igm;
export var extractThumbnailPath = function (url) {
    var extractedPath = url.split(URL_DOMAIN_REGEX).pop();
    if (url.startsWith('https://s3.amazonaws.com/')) {
        var bucketName = extractedPath.split('/')[0];
        return extractedPath.replace(bucketName + "/", '');
    }
    return extractedPath;
};
